import type { VariantOption } from "../types/earmold.types";
import { getVariantMismatchInfo } from "../pages/orders/components/getVariantMismatchInfo.ts";

export const getHasVariantMismatchWarning = ({
	hasLeftEar,
	hasRightEar,
	currentValue,
	oppositeValue,
}: {
	hasLeftEar: boolean;
	hasRightEar: boolean;
	currentValue: VariantOption | null | undefined;
	oppositeValue: VariantOption | null | undefined;
}) => {
	if (hasLeftEar === false || hasRightEar === false) {
		return false;
	}

	return getVariantMismatchInfo(currentValue, oppositeValue)
		.isDifferentBetweenSides;
};
